import React, { useEffect, useState, createElement } from 'react';
import { CTAButton } from '../components/CTAButton';
import { BonusCard } from '../components/BonusCard';
import { TestimonialCard } from '../components/TestimonialCard';
import { PurchasePopup } from '../components/PurchasePopup';
import { Check, ShieldCheck, Clock, Award, X, Map, Layout, Zap, Shield, Plus, Minus } from 'lucide-react';
export function LandingPage() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  // Initialize Meta Pixel
  useEffect(() => {
    // Load Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '890245410416880');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=890245410416880&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      // Cleanup on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, []);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  const scrollToOffer = () => {
    const element = document.getElementById('final-offer');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const faqs = [{
    question: '¿Qué recibo al comprar el Kit?',
    answer: 'Accedés al Kit Bilingüe 21 Días completo, con el sistema paso a paso y todos los bonos incluidos.'
  }, {
    question: '¿Cuándo me llega?',
    answer: 'El acceso es inmediato una vez confirmada la compra.'
  }, {
    question: '¿Es físico o digital?',
    answer: 'Es 100% digital. Podés acceder desde cualquier dispositivo.'
  }, {
    question: '¿Necesito conocimientos previos?',
    answer: 'No. Está diseñado para nivel bajo o intermedio frustrado.'
  }, {
    question: '¿Es una compra segura?',
    answer: 'Sí. El pago es seguro y tenés garantía para probarlo sin riesgo.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-800 selection:bg-blue-100 selection:text-blue-900" data-id="element-39">
      {/* Top Bar */}
      <div className="bg-blue-600 text-white py-2 text-center text-sm font-medium tracking-wide" data-id="element-40">
        🔥 Oferta especial disponible por tiempo limitado
      </div>

      <main className="w-full" data-id="element-41">
        {/* 1. HERO SECTION - Ultra Compact Layout */}
        <section className="max-w-6xl mx-auto px-4 py-4 md:py-6 text-center" data-id="element-42">
          {/* 1. TÍTULO */}
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight max-w-4xl mx-auto" data-id="element-43">
            Dominá el inglés y empezá a generar en dólares
          </h1>

          {/* 2. MOCKUP (Con padding-top negativo de -100px) */}
          <div className="relative group cursor-pointer w-full max-w-md mx-auto" style={{
          marginTop: '-100px'
        }} onClick={scrollToOffer} data-id="element-44">
            <img src="https://cdn.magicpatterns.com/uploads/q7JpLCLGKcqmJyDhpLUuv8/19d8c578-63f0-487a-9e08-c562d97bb2ac-Photoroom_(1).png" alt="Kit Bilingüe 21 Días" className="w-full transform transition duration-500 hover:scale-[1.02] drop-shadow-2xl" data-id="element-45" />
          </div>

          {/* Todo lo que está debajo del mockup con espaciado negativo de -70px */}
          <div style={{
          marginTop: '-70px'
        }} data-id="element-46">
            {/* 3. SUBTÍTULO */}
            <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto mb-2 leading-relaxed font-medium px-4" data-id="element-47">
              Sistema probado para ver resultados reales en{' '}
              <span className="font-bold text-red-600" data-id="element-48">21 días</span> y
              convertir el inglés en una{' '}
              <span className="font-bold text-blue-600" data-id="element-49">habilidad laboral</span>{' '}
              de uso internacional.
            </p>

            {/* 4. CTA */}
            <div className="mt-2" data-id="element-50">
              <CTAButton scrollTo="final-offer" className="bg-gradient-to-r from-red-600 to-red-500 hover:from-red-500 hover:to-red-400 shadow-red-200" data-id="element-51">
                QUIERO ACCESO INMEDIATO
              </CTAButton>
            </div>

            {/* Trust badges */}
            <div className="mt-3 flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-gray-500 font-medium" data-id="element-52">
              <div className="flex items-center gap-2" data-id="element-53">
                <Check className="w-5 h-5 text-green-500 bg-green-100 rounded-full p-1" data-id="element-54" />{' '}
                Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-55">
                <Check className="w-5 h-5 text-green-500 bg-green-100 rounded-full p-1" data-id="element-56" />{' '}
                Garantía 7 días
              </div>
              <div className="flex items-center gap-2" data-id="element-57">
                <Check className="w-5 h-5 text-green-500 bg-green-100 rounded-full p-1" data-id="element-58" />{' '}
                Acceso de por vida
              </div>
            </div>
          </div>
        </section>

        {/* 2. PROBLEM SECTION (Two Columns) - SIC 360 Style */}
        <section className="max-w-5xl mx-auto px-4 py-12" data-id="element-59">
          <div className="bg-gray-50 rounded-3xl p-8 md:p-12 text-center mb-12 border border-gray-100 shadow-sm" data-id="element-60">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-61">
              ¿Sentís que te esforzás pero{' '}
              <span className="text-red-600" data-id="element-62">no avanzás?</span>
            </h2>
            <p className="text-lg text-gray-600" data-id="element-63">
              El problema <span className="font-bold" data-id="element-64">no sos vos.</span> Es que{' '}
              <span className="text-red-600 font-bold" data-id="element-65">
                nadie te dio una estructura clara.
              </span>
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-66">
            {/* Left Column - Green */}
            <div className="bg-green-50 rounded-2xl p-8 border border-green-100" data-id="element-67">
              <div className="flex items-center gap-3 mb-6" data-id="element-68">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-69">
                  <Check className="w-6 h-6 text-green-600" data-id="element-70" />
                </div>
                <h3 className="text-xl font-bold text-green-800" data-id="element-71">
                  Lo que ves en otros
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-72">
                <li className="flex items-start gap-3" data-id="element-73">
                  <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-74" />
                  <span className="text-gray-700" data-id="element-75">Gente trabajando remoto</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-76">
                  <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-77" />
                  <span className="text-gray-700" data-id="element-78">Cobrando en dólares</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-79">
                  <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-80" />
                  <span className="text-gray-700" data-id="element-81">
                    Consiguiendo clientes afuera
                  </span>
                </li>
              </ul>
            </div>

            {/* Right Column - Red */}
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100" data-id="element-82">
              <div className="flex items-center gap-3 mb-6" data-id="element-83">
                <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center" data-id="element-84">
                  <X className="w-6 h-6 text-red-600" data-id="element-85" />
                </div>
                <h3 className="text-xl font-bold text-red-800" data-id="element-86">
                  Pero tu realidad es esta
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-87">
                <li className="flex items-start gap-3" data-id="element-88">
                  <X className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" data-id="element-89" />
                  <span className="text-gray-700" data-id="element-90">
                    Ves ofertas "English required"
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-91">
                  <X className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" data-id="element-92" />
                  <span className="text-gray-700" data-id="element-93">
                    Pensás "Podría aplicar... si supiera"
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-94">
                  <X className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" data-id="element-95" />
                  <span className="text-gray-700" data-id="element-96">
                    Oportunidades que no podés tocar
                  </span>
                </li>
              </ul>
              <div className="mt-6 pt-6 border-t border-red-200 text-center" data-id="element-97">
                <p className="text-red-800 font-bold italic" data-id="element-98">
                  "No soy menos inteligente… solo me quedé atrás."
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-8" data-id="element-99">
            <p className="text-gray-600 font-medium" data-id="element-100">
              Te esforzás, pero{' '}
              <span className="text-red-600 font-bold" data-id="element-101">algo no baja.</span>
            </p>
          </div>
        </section>

        {/* 3. LO QUE NADIE DICE - SIC 360 Style */}
        <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-102">
          <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-103">
            Lo que <span className="text-orange-500" data-id="element-104">nadie dice</span> en voz
            alta
          </h2>
          <div className="inline-block bg-yellow-100 px-3 py-1 rounded-md mb-6" data-id="element-105">
            <span className="font-bold text-yellow-800" data-id="element-106">
              El problema no sos vos.
            </span>
          </div>

          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-107">
            Hay una vergüenza que casi nadie admite. Vergüenza de decir que no
            sabés inglés. Vergüenza de empezar desde cero. Vergüenza de
            pronunciar mal. Vergüenza de volver a fallar.
          </p>

          <div className="bg-blue-50 rounded-2xl p-8 border border-blue-100" data-id="element-108">
            <h3 className="font-bold text-blue-900 mb-4" data-id="element-109">
              Cuando en realidad debería empezarse por:
            </h3>
            <ul className="space-y-3" data-id="element-110">
              <li className="flex items-center gap-2 text-blue-800 font-medium" data-id="element-111">
                <div className="w-2 h-2 bg-blue-600 rounded-full" data-id="element-112"></div>
                Una estructura clara
              </li>
              <li className="flex items-center gap-2 text-blue-800 font-medium" data-id="element-113">
                <div className="w-2 h-2 bg-blue-600 rounded-full" data-id="element-114"></div>
                Inglés útil para el mercado laboral
              </li>
              <li className="flex items-center gap-2 text-orange-600 font-bold" data-id="element-115">
                <div className="w-2 h-2 bg-orange-500 rounded-full" data-id="element-116"></div>
                Resultados visibles en semanas
              </li>
            </ul>
          </div>
        </section>

        {/* 4. SOLUTION INTRO - SIC 360 Style */}
        <section className="max-w-6xl mx-auto px-4 py-16 text-center" data-id="element-117">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-118">
            Y ahí aparece{' '}
            <span className="text-blue-600" data-id="element-119">Kit Bilingüe 21 Días</span>
          </h2>

          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-12" data-id="element-120">
            No es un curso tradicional. No es gramática infinita. Es un{' '}
            <span className="font-bold text-gray-900" data-id="element-121">
              sistema guiado de desbloqueo profesional
            </span>
            , pensado para adultos reales.
          </p>

          <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 md:p-12" data-id="element-122">
            <div className="grid md:grid-cols-3 gap-8 text-left" data-id="element-123">
              <div className="space-y-4 relative" data-id="element-124">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-125">
                  Para qué
                </span>
                <h3 className="text-xl font-bold text-blue-600" data-id="element-126">
                  Desbloqueo Profesional
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-127">
                  Para dejar de sentirte estancado y empezar a construir una
                  salida real, posible y silenciosa.
                </p>
                <div className="hidden md:block absolute top-0 right-0 h-full w-px bg-gray-100" data-id="element-128"></div>
              </div>

              <div className="space-y-4 relative" data-id="element-129">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-130">
                  Cómo
                </span>
                <h3 className="text-xl font-bold text-blue-600" data-id="element-131">
                  Sistema Guiado
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-132">
                  Te muestra qué estudiar y en qué orden. Elimina lo
                  innecesario. Te guía paso a paso, día por día.
                </p>
                <div className="hidden md:block absolute top-0 right-0 h-full w-px bg-gray-100" data-id="element-133"></div>
              </div>

              <div className="space-y-4" data-id="element-134">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-135">
                  Qué
                </span>
                <h3 className="text-xl font-bold text-blue-600" data-id="element-136">
                  Inglés Laboral
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-137">
                  Se enfoca solo en el inglés útil para el mercado laboral. Te
                  permite ver progreso en semanas, no en años.
                </p>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col md:flex-row items-center justify-center gap-4 text-center" data-id="element-138">
              <div className="flex items-center gap-2 text-green-600 font-medium" data-id="element-139">
                <Check className="w-5 h-5" data-id="element-140" /> No improvisás
              </div>
              <div className="flex items-center gap-2 text-green-600 font-medium" data-id="element-141">
                <Check className="w-5 h-5" data-id="element-142" /> No te abrumás
              </div>
              <p className="text-orange-500 font-bold flex items-center gap-2" data-id="element-143">
                <span className="text-xl" data-id="element-144">👉</span> Seguís el camino
              </p>
            </div>
          </div>
        </section>

        {/* 5. PENSALO ASÍ - SIC 360 Style */}
        <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-145">
          <h2 className="text-2xl font-bold text-center mb-8" data-id="element-146">Pensalo así</h2>

          <div className="space-y-4" data-id="element-147">
            <div className="bg-white rounded-xl border border-gray-200 p-6 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-148">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-149">
                <Map className="w-6 h-6 text-orange-600" data-id="element-150" />
              </div>
              <div data-id="element-151">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-152">
                  Un GPS profesional
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-153">
                  Sabés el recorrido.{' '}
                  <span className="font-bold text-orange-600" data-id="element-154">
                    No improvisás.
                  </span>
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-200 p-6 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-155">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-156">
                <Layout className="w-6 h-6 text-blue-600" data-id="element-157" />
              </div>
              <div data-id="element-158">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-159">
                  Una estructura sólida
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-160">
                  Primero cimientos. Después estructura.{' '}
                  <span className="font-bold" data-id="element-161">Sin huecos.</span>
                </p>
              </div>
            </div>

            <div className="bg-white rounded-xl border border-gray-200 p-6 flex items-start gap-4 hover:shadow-md transition-shadow" data-id="element-162">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-163">
                <Zap className="w-6 h-6 text-purple-600" data-id="element-164" />
              </div>
              <div data-id="element-165">
                <h3 className="font-bold text-gray-900 mb-1" data-id="element-166">
                  Un acelerador de resultados
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-167">
                  Podés volar igual... pero con esto{' '}
                  <span className="font-bold text-orange-600" data-id="element-168">
                    todo es más rápido.
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 rounded-2xl p-8 mt-12 border border-blue-100" data-id="element-169">
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-170">
              Kit Bilingüe nació de una{' '}
              <span className="text-orange-600" data-id="element-171">frustración real</span>
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-172">
              De ver gente capaz perdiendo oportunidades. De ver profesionales
              estancados por el idioma. De cursos eternos que no llevan a nada.
            </p>
            <p className="font-bold text-blue-900" data-id="element-173">
              La pregunta fue simple: ¿Y si el problema no sos vos...{' '}
              <span className="text-orange-600" data-id="element-174">
                sino la falta de estructura?
              </span>
            </p>
          </div>
        </section>

        {/* 6. RESULTS/TRANSFORMATION - SIC 360 Style */}
        <section className="max-w-6xl mx-auto px-4 py-16" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12" data-id="element-176">
            Resultados que <span className="text-blue-600" data-id="element-177">transforman</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-178">
            {/* Left - Blue (Students/You) */}
            <div className="bg-white rounded-3xl border border-blue-100 shadow-lg p-8 h-full" data-id="element-179">
              <div className="flex items-center gap-3 mb-6" data-id="element-180">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white" data-id="element-181">
                  <Layout className="w-6 h-6" data-id="element-182" />
                </div>
                <h3 className="text-xl font-bold text-blue-600" data-id="element-183">
                  Qué lográs vos
                </h3>
              </div>

              <ul className="space-y-4" data-id="element-184">
                <li className="flex items-start gap-3 bg-blue-50 p-3 rounded-lg" data-id="element-185">
                  <Check className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-186" />
                  <span className="text-gray-700 text-sm" data-id="element-187">
                    Sabés exactamente qué estudiar hoy
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-blue-50 p-3 rounded-lg" data-id="element-188">
                  <Check className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-189" />
                  <span className="text-gray-700 text-sm" data-id="element-190">
                    Empezás a entender el idioma real
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-blue-50 p-3 rounded-lg" data-id="element-191">
                  <Check className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-192" />
                  <span className="text-gray-700 text-sm" data-id="element-193">
                    Te animás a leer ofertas internacionales
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-blue-50 p-3 rounded-lg" data-id="element-194">
                  <Check className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" data-id="element-195" />
                  <span className="text-gray-700 text-sm" data-id="element-196">
                    Volvés a confiar en tu palabra
                  </span>
                </li>
              </ul>
            </div>

            {/* Right - Green (Outcome) */}
            <div className="bg-white rounded-3xl border border-green-100 shadow-lg p-8 h-full" data-id="element-197">
              <div className="flex items-center gap-3 mb-6" data-id="element-198">
                <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center text-white" data-id="element-199">
                  <Award className="w-6 h-6" data-id="element-200" />
                </div>
                <h3 className="text-xl font-bold text-green-600" data-id="element-201">
                  Qué obtenés hoy
                </h3>
              </div>

              <ul className="space-y-4" data-id="element-202">
                <li className="flex items-start gap-3 bg-green-50 p-3 rounded-lg" data-id="element-203">
                  <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-204" />
                  <span className="text-gray-700 text-sm" data-id="element-205">
                    <span className="font-bold" data-id="element-206">Ahorrar años</span> de estudio
                    sin rumbo
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-green-50 p-3 rounded-lg" data-id="element-207">
                  <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-208" />
                  <span className="text-gray-700 text-sm" data-id="element-209">
                    Dejar de improvisar y dudar
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-green-50 p-3 rounded-lg" data-id="element-210">
                  <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-211" />
                  <span className="text-gray-700 text-sm" data-id="element-212">
                    Tener{' '}
                    <span className="font-bold" data-id="element-213">todo el camino organizado</span>
                  </span>
                </li>
                <li className="flex items-start gap-3 bg-green-50 p-3 rounded-lg" data-id="element-214">
                  <Check className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-215" />
                  <span className="text-gray-700 text-sm" data-id="element-216">
                    Avanzar con{' '}
                    <span className="font-bold text-orange-600" data-id="element-217">
                      claridad y seguridad
                    </span>
                  </span>
                </li>
              </ul>

              <div className="mt-6" data-id="element-218">
                <CTAButton fullWidth scrollTo="final-offer" className="text-sm py-3 bg-blue-600 hover:bg-blue-700" data-id="element-219">
                  QUIERO LOGRAR ESTO
                </CTAButton>
                <p className="text-center text-xs text-gray-400 mt-2" data-id="element-220">
                  Pago 100% seguro y encriptado
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 7. BONUSES SECTION - SIC 360 Style */}
        <section className="max-w-6xl mx-auto px-4 py-16" data-id="element-221">
          <div className="text-center mb-12" data-id="element-222">
            <span className="bg-green-100 text-green-800 px-4 py-1 rounded-full font-bold text-xs uppercase tracking-wider mb-4 inline-block" data-id="element-223">
              GRATIS POR HOY
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-224">
              Llevate estos 4 Bonos Exclusivos
            </h2>
            <p className="text-gray-600 mt-4 max-w-2xl mx-auto" data-id="element-225">
              Herramientas complementarias para blindar tu aprendizaje.
              Incluidos sin cargo con tu compra.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-226">
            <BonusCard number={1} title="Los 25 Errores Más Comunes" imageUrl="https://cdn.magicpatterns.com/uploads/e6DNLqEEQE77dMrtbaHhzH/bonus_1.png" features={['Evitá los errores que hacen abandonar al 90%', 'Dejá de culparte y empezá a avanzar', 'Sabé exactamente qué NO hacer']} data-id="element-227" />
            <BonusCard number={2} title="Guía de Self-Teaching" imageUrl="https://cdn.magicpatterns.com/uploads/rUkQhG7zN6END8fgBLCR8h/bonus_2.jpg" features={['Estudiá solo lo que importa', 'Medí progreso real, no sensación', 'Avanzá incluso con poco tiempo']} data-id="element-228" />
            <BonusCard number={3} title="Mapa del Inglés Laboral" imageUrl="https://cdn.magicpatterns.com/uploads/hZnXJnL5cyddaY5TtBmDAm/cover_3.png" features={['Enfocate en lo que el mercado paga', 'Eliminá el humo de los cursos tradicionales', 'Mirá el tablero completo desde el día 1']} data-id="element-229" />
            <BonusCard number={4} title="Plan de Continuidad" imageUrl="https://cdn.magicpatterns.com/uploads/mU15cyMvTam1jetiRh2Lim/bonus_4.jpg" features={['Evitá quedarte estancado después del programa', 'Tené claridad total sobre el "qué sigue"', 'Convertí el hábito en progreso real']} data-id="element-230" />
          </div>
        </section>

        {/* 8. PRICING SECTION - Expanded descriptions */}
        <section id="final-offer" className="w-full bg-blue-600 py-20 px-4 text-white" data-id="element-231">
          <div className="max-w-4xl mx-auto text-center" data-id="element-232">
            <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-233">
              Empezá hoy mismo
            </h2>
            <p className="text-blue-100 mb-12 text-lg" data-id="element-234">
              Todo lo que necesitás para desbloquear tu inglés sin estrés
            </p>

            <div className="bg-white text-gray-900 rounded-3xl p-8 md:p-12 shadow-2xl max-w-lg mx-auto transform hover:scale-[1.01] transition-transform duration-300" data-id="element-235">
              <div className="mb-8" data-id="element-236">
                <img src="https://cdn.magicpatterns.com/uploads/q7JpLCLGKcqmJyDhpLUuv8/19d8c578-63f0-487a-9e08-c562d97bb2ac-Photoroom_(1).png" alt="Kit Bilingüe 21 Días" className="w-48 mx-auto drop-shadow-xl mb-6" data-id="element-237" />
                <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-238">
                  Kit Bilingüe 21 Días
                </h3>
                <div className="flex items-center justify-center gap-2 mb-1" data-id="element-239">
                  <span className="text-gray-400 line-through text-lg" data-id="element-240">
                    $49.990
                  </span>
                  <span className="bg-red-100 text-red-600 text-xs font-bold px-2 py-1 rounded uppercase" data-id="element-241">
                    Oferta
                  </span>
                </div>
                <div className="text-5xl font-extrabold text-blue-600 mb-2" data-id="element-242">
                  $19.990
                </div>
                <p className="text-green-600 text-sm font-bold" data-id="element-243">
                  Ahorrás $30.000 hoy
                </p>
              </div>

              <div className="space-y-4 mb-8 text-left bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-244">
                <div className="flex items-start gap-3" data-id="element-245">
                  <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-246">
                    <Check className="w-3 h-3 text-green-600" data-id="element-247" />
                  </div>
                  <span className="text-sm leading-relaxed" data-id="element-248">
                    <span className="font-bold" data-id="element-249">
                      Sistema Completo de 21 Días:
                    </span>{' '}
                    No solo incluye el programa paso a paso, sino que te permite
                    seguir una estructura clara y probada para convertir el
                    inglés en una habilidad laboral real sin perderte en el
                    camino.
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-250">
                  <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-251">
                    <Check className="w-3 h-3 text-green-600" data-id="element-252" />
                  </div>
                  <span className="text-sm leading-relaxed" data-id="element-253">
                    <span className="font-bold" data-id="element-254">4 Bonos Exclusivos:</span>{' '}
                    Herramientas complementarias diseñadas para blindar tu
                    aprendizaje, evitar los errores más comunes y mantener el
                    progreso incluso después de completar el programa principal.
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-255">
                  <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-256">
                    <Check className="w-3 h-3 text-green-600" data-id="element-257" />
                  </div>
                  <span className="text-sm leading-relaxed" data-id="element-258">
                    <span className="font-bold" data-id="element-259">
                      Acceso Inmediato y Vitalicio:
                    </span>{' '}
                    Empezás hoy mismo sin esperas, y tenés acceso de por vida
                    para repasar, reforzar y seguir avanzando a tu propio ritmo,
                    sin vencimientos ni presiones.
                  </span>
                </div>
              </div>

              <CTAButton fullWidth className="mb-4 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700" data-id="element-260">
                QUIERO ACCESO INMEDIATO
              </CTAButton>

              <div className="flex items-center justify-center gap-4 text-xs text-gray-500" data-id="element-261">
                <div className="flex items-center gap-1" data-id="element-262">
                  <Check className="w-3 h-3 text-green-500" data-id="element-263" /> Descarga
                  inmediata
                </div>
                <div className="flex items-center gap-1" data-id="element-264">
                  <Check className="w-3 h-3 text-green-500" data-id="element-265" /> Garantía 7 días
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 9. GUARANTEE SECTION - SIC 360 Style */}
        <section className="bg-blue-600 pb-20 px-4 text-white text-center" data-id="element-266">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-lg text-gray-900 relative -mt-10 z-10" data-id="element-267">
            <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg border-4 border-white -mt-20" data-id="element-268">
              <Shield className="w-8 h-8 text-white" data-id="element-269" />
            </div>

            <h2 className="text-2xl font-bold text-blue-900 mb-4" data-id="element-270">
              Garantía sin vueltas
            </h2>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto" data-id="element-271">
              Estamos tan seguros de que este Programa te va a encantar, que si
              no es así,{' '}
              <span className="font-bold text-gray-900" data-id="element-272">
                te devolvemos el 100% de tu dinero.
              </span>
            </p>
            <p className="text-sm text-gray-500" data-id="element-273">
              Tenés <span className="font-bold text-red-500" data-id="element-274">7 días</span> para
              probarlo sin riesgo. Si no te convence, nos escribís y te hacemos
              el reembolso. <span className="font-bold" data-id="element-275">Así de simple.</span>
            </p>
          </div>
        </section>

        {/* 10. TESTIMONIALS SECTION - SIC 360 Style */}
        <section className="max-w-6xl mx-auto px-4 py-20" data-id="element-276">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-277">
            Lo que dicen otros usuarios
          </h2>
          <p className="text-center text-gray-500 mb-12" data-id="element-278">
            Personas reales que ya están transformando su futuro con el Kit
            Bilingüe.
          </p>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-279">
            <TestimonialCard name="Sofía Martínez" city="Córdoba" initial="S" text="Siempre pensé que el inglés no era para mí. Había probado institutos y apps, pero me aburría. Con el Kit entendí que no tenía que estudiar todo, solo lo que sirve. Hoy tuve mi primera entrevista en inglés y me sentí segura." data-id="element-280" />
            <TestimonialCard name="Diego Fernández" city="Buenos Aires" initial="D" text="Trabajo en sistemas y me perdía ofertas por no saber inglés. El Kit me dio la estructura que necesitaba. No es mágico, hay que ponerle ganas, pero sabés exactamente qué hacer cada día. Muy recomendado." data-id="element-281" />
            <TestimonialCard name="Laura Gómez" city="Rosario" initial="L" text="Lo compré con dudas, pero me sorprendió. Los bonos son excelentes, especialmente el de los errores comunes. Me di cuenta de que me frenaba el miedo a equivocarme. Ahora me animo a hablar sin vergüenza." data-id="element-282" />
            <div className="hidden md:block" data-id="element-283">
              <TestimonialCard name="Martín Rodriguez" city="Mendoza" initial="M" text="La guía de self-teaching es oro. Trabajo todo el día y tengo poco tiempo. Poder organizar mi estudio de forma eficiente fue la clave. Ya no siento que estoy perdiendo el tiempo." data-id="element-284" />
            </div>
            <div className="hidden md:block" data-id="element-285">
              <TestimonialCard name="Valentina Ruiz" city="La Plata" initial="V" text="El enfoque laboral es lo que buscaba. Nada de 'el gato está debajo de la mesa'. Fui directo a lo que necesitaba para mi CV y entrevistas. La inversión se paga sola." data-id="element-286" />
            </div>
            <div className="hidden md:block" data-id="element-287">
              <TestimonialCard name="Lucas Méndez" city="Tucumán" initial="L" text="La estructura de 21 días es real. No te hacés bilingüe en 3 semanas, pero desbloqueás el miedo y entendés el camino. Es el empujón que necesitaba para dejar de procrastinar." data-id="element-288" />
            </div>
          </div>
        </section>

        {/* 11. FAQ SECTION - Interactive Accordion */}
        <section className="max-w-3xl mx-auto px-4 pb-20" data-id="element-289">
          <h2 className="text-2xl font-bold text-center text-blue-900 mb-8" data-id="element-290">
            Resolvé aquí tus DUDAS
          </h2>

          <div className="space-y-4" data-id="element-291">
            {faqs.map((faq, index) => <div key={index} className={`border rounded-lg overflow-hidden transition-all duration-300 ${openFaqIndex === index ? 'border-blue-300 bg-blue-50/30' : 'border-gray-200 hover:border-blue-300 bg-white'}`} data-id="element-292">
                <button onClick={() => toggleFaq(index)} className="w-full flex justify-between items-center p-4 text-left focus:outline-none" aria-expanded={openFaqIndex === index} data-id="element-293">
                  <h3 className={`font-bold transition-colors ${openFaqIndex === index ? 'text-blue-600' : 'text-gray-800'}`} data-id="element-294">
                    {faq.question}
                  </h3>
                  <div className={`flex-shrink-0 ml-4 transition-transform duration-300 ${openFaqIndex === index ? 'rotate-180' : ''}`} data-id="element-295">
                    {openFaqIndex === index ? <Minus className="w-5 h-5 text-blue-500" data-id="element-296" /> : <Plus className="w-5 h-5 text-blue-500" data-id="element-297" />}
                  </div>
                </button>

                <div className={`grid transition-all duration-300 ease-in-out ${openFaqIndex === index ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-298">
                  <div className="overflow-hidden" data-id="element-299">
                    <p className="px-4 pb-4 text-gray-600 leading-relaxed" data-id="element-300">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        <footer className="py-8 text-center text-gray-400 text-sm border-t border-gray-100 bg-gray-50" data-id="element-301">
          <p data-id="element-302">© 2024 Kit Bilingüe 21 Días. Todos los derechos reservados.</p>
        </footer>
      </main>

      <PurchasePopup data-id="element-303" />
    </div>;
}